import React, { useState } from 'react';
import { Box, Paper, Tabs, Tab, Typography } from '@mui/material';
import { Business as DepartmentIcon, Group as GroupIcon } from '@mui/icons-material';
import { Title } from 'react-admin';
import DepartmentManagement from './DepartmentManagement';
import UserGroupManagement from './UserGroupManagement';

const OrganizationSettings: React.FC = () => {
    const [tabValue, setTabValue] = useState(0);

    return (
        <Box sx={{ padding: 3 }}>
            <Title title="Organisationseinstellungen" />

            <Paper sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                <Tabs
                    value={tabValue}
                    onChange={(e, newValue) => setTabValue(newValue)}
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        bgcolor: '#f5f5f5'
                    }}
                >
                    <Tab
                        label="Abteilungen"
                        icon={<DepartmentIcon />}
                        iconPosition="start"
                        sx={{
                            minHeight: 64,
                            fontSize: '1rem',
                            fontWeight: tabValue === 0 ? 600 : 400
                        }}
                    />
                    <Tab
                        label="Benutzergruppen"
                        icon={<GroupIcon />}
                        iconPosition="start"
                        sx={{
                            minHeight: 64,
                            fontSize: '1rem',
                            fontWeight: tabValue === 1 ? 600 : 400
                        }}
                    />
                </Tabs>

                <Box sx={{ padding: 3 }}>
                    {tabValue === 0 && <DepartmentManagement />}
                    {tabValue === 1 && <UserGroupManagement />}
                </Box>
            </Paper>
        </Box>
    );
};

export default OrganizationSettings;
